/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 19:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Heading, Badge, Button, SkeletonBodyText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { URL } from 'src/constants/links';
import * as dashboardV3Action from 'actions/dashboard-v3-actions';

type ComposedProps = Props & WithI18nProps;
class ChangeLogs extends Component<ComposedProps> {
  componentDidMount() {
    this.props.getChangeLogs();
  }
  render() {
    const { i18n, changeLogs, gettingChangeLogs } = this.props;
    const date = _.get(changeLogs, 'name', '');
    const allChanges = _.get(changeLogs, 'changes', []);
    const changeLogBadges = this.getChangeBadges(allChanges);

    return (
      <div className="BC-ChangeLogs__Dashboard">
        <Card sectioned>
          <Heading>{i18n.translate('AdminHTML.DashboardV3.ChangeLogs.title')}</Heading>
          {gettingChangeLogs ? (
            <div className="date">
              <SkeletonBodyText lines={5} />
            </div>
          ) : (
            <>
              <div className="date">{date}</div>
              <div className="list-badge">
                {changeLogBadges.map(log => (
                  <Badge key={log.priority} status={log.status}>
                    {i18n.translate(`AdminHTML.DashboardV3.ChangeLogs.badged_${log.tag}`)}
                  </Badge>
                ))}
              </div>
              {/* {allChanges.map((change, changeIndex) => (
                <div className="detail-logs" key={`change-${changeIndex}`}>
                  <TextStyle variation="strong">
                    {`[${_.upperFirst(_.get(change, 'tag', 'New feature'))}]`}
                  </TextStyle>
                  <ul>
                    {_.get(change, 'lines', []).map((e, index) => (
                      <li key={`line-${index}`}>{e}</li>
                    ))}
                  </ul>
                </div>
              ))} */}
              <Button onClick={this.openLink}>
                {i18n.translate('AdminHTML.DashboardV3.ChangeLogs.actionLabel')}
              </Button>
            </>
          )}
        </Card>
      </div>
    );
  }

  openLink = () => {
    window.open(URL['ChangeLogs'], '_blank');
  };

  getChangeBadges = allChanges => {
    const changeBadges = [];
    for (const change of allChanges) {
      let customTag = _.lowerCase(change.tag);

      if (_.lowerCase(change.tag).includes('feature') || _.lowerCase(change.tag).includes('new'))
        customTag = 'newfeature';

      if (_.lowerCase(change.tag).includes('improved')) customTag = 'improvement';

      if (!changeBadges.some(e => e.tag === customTag)) {
        switch (customTag) {
          case 'newfeature': {
            changeBadges.push({ tag: customTag, priority: 1, status: 'info' });
            break;
          }
          case 'integration': {
            changeBadges.push({ tag: customTag, priority: 2, status: 'new' });
            break;
          }
          case 'fix': {
            changeBadges.push({ tag: customTag, priority: 3, status: 'warning' });
            break;
          }
          case 'improvement': {
            changeBadges.push({ tag: customTag, priority: 4, status: 'success' });
            break;
          }
          default:
            break;
        }
      }
    }

    return changeBadges.sort((a, b) => a.priority - b.priority);
  };
}
const mapStateToProps = (state, props) => {
  return {
    changeLogs: _.get(state.dashboardV3, 'changeLogs', {}),
    gettingChangeLogs: _.get(state.dashboardV3, 'gettingChangeLogs', {})
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getChangeLogs: () => dispatch(dashboardV3Action.getChangeLogs(ownProps.i18n))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ChangeLogs));
